import { Capacitor } from "@capacitor/core";

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

export function isMobileBuild(): boolean {
  return import.meta.env.VITE_NATIVE_BUILD === "true" || isNativeApp();
}

export function apiUrl(path: string): string {
  return resolveApiUrl(path, import.meta.env.VITE_API_ORIGIN, isMobileBuild());
}

export function resolveApiUrl(path: string, configuredOrigin: unknown, native: boolean): string {
  if (!path.startsWith("/api/") || /[\\?#]/.test(path) || path.includes("..")) {
    throw new Error("Invalid API path.");
  }
  if (!native) return path;
  if (typeof configuredOrigin !== "string") throw new Error("The app's online service is not configured.");
  const origin = new URL(configuredOrigin);
  if (origin.protocol !== "https:" || origin.origin !== configuredOrigin) {
    throw new Error("The app's online service must use a secure origin.");
  }
  return `${origin.origin}${path}`;
}
